import React, { useState } from "react";
import axios from "axios";
import API_URL from "../../config";

const BulkWhatsAppForm = () => {
  const [template, setTemplate] = useState("");
  const [target, setTarget] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!template || !target || !file) {
      setMessage({
        type: "danger",
        text: "Template, Target Audience aur Excel file teeno required hain.",
      });
      return;
    }

    const formData = new FormData();
    formData.append("templateName", template);
    formData.append("targetAudience", target);
    formData.append("excelFile", file);

    setLoading(true);
    setMessage(null);

    try {
      const response = await axios.post(
        `${API_URL}/api/admin/message/send-bulk-whatsapp`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setMessage({
        type: "success",
        text: `${response.data.message} | Total: ${response.data.totalProcessed} | Success: ${response.data.success} | Failed: ${response.data.failed}`,
      });

      setTemplate("");
      setTarget("");
      setFile(null);
      e.target.reset();
    } catch (error) {
      setMessage({
        type: "danger",
        text:
          error.response?.data?.error ||
          "Kuch galat ho gaya. Server check karein.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <div
        className="card shadow border-0"
        style={{ maxWidth: "600px", margin: "0 auto" }}
      >
        <div className="card-header bg-primary text-white text-center py-3">
          <h4 className="mb-0">Bulk WhatsApp Outreach</h4>
        </div>

        <div className="card-body p-4">
          {message && (
            <div
              className={`alert alert-${message.type} alert-dismissible fade show`}
              role="alert"
            >
              {message.text}
              <button
                type="button"
                className="btn-close"
                onClick={() => setMessage(null)}
              ></button>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label fw-bold">
                Select Template <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                value={template}
                onChange={(e) => setTemplate(e.target.value)}
                required
              >
                <option value="">-- Template chunein --</option>
                <option value="institution_outreach_eim">
                  Institution Outreach EIM
                </option>
                <option value="startup_bulk_outreach_eim">
                  Startup Bulk Outreach EIM
                </option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">
                Select Target Audience <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                value={target}
                onChange={(e) => setTarget(e.target.value)}
                required
              >
                <option value="">-- Kise bhejna hai chunein --</option>
                <option value="institution">Institutions</option>
                <option value="startups">Startups</option>
              </select>
            </div>

            <div className="mb-4 p-3 bg-light rounded border">
              <label className="form-label fw-bold">
                Upload Excel File <span className="text-danger">*</span>
              </label>
              <input
                type="file"
                className="form-control mb-2"
                accept=".xlsx,.xls"
                required
                onChange={(e) => setFile(e.target.files[0])}
              />
              <small className="text-muted d-block">
                Excel file required hai. Columns: <strong>Name</strong> and{" "}
                <strong>Number</strong>.
              </small>
            </div>

            <div className="d-grid">
              <button
                type="submit"
                className="btn btn-primary btn-lg"
                disabled={loading}
              >
                {loading ? "Sending Messages..." : "Send Bulk Campaign"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BulkWhatsAppForm;